import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfiguratorRenewalAction } from '@models';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';
import { environment } from '@environments/environment';

export interface GetRenewalActionsParams extends DefaultHttpHeaders {}

@Injectable()
export class GetRenewalActionsService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  getRenewalActions(params: GetRenewalActionsParams): Observable<ConfiguratorRenewalAction[]> {
    return this.get<ConfiguratorRenewalAction[]>({
      suffix: '/configurator/policy/renewal/actions',
      apiUrl: environment.configuratorApiUrl,
    });
  }
}
